import { LOCAL_STORAGE_ITEM_NAMES, SESSION_STORAGE_ITEM_NAMES } from "../components/domain/constants";
import { stringToList, stringToObj } from "./StringUtil";
export function clearUserDataFromLocalStorage() {
  localStorage.removeItem(LOCAL_STORAGE_ITEM_NAMES.partners);
  localStorage.removeItem(LOCAL_STORAGE_ITEM_NAMES.username);
  localStorage.removeItem(LOCAL_STORAGE_ITEM_NAMES.role);
  localStorage.removeItem(LOCAL_STORAGE_ITEM_NAMES.capabilities);
  localStorage.removeItem(LOCAL_STORAGE_ITEM_NAMES.specialSelectionRules);
  localStorage.removeItem(LOCAL_STORAGE_ITEM_NAMES.defaultAspectRatio);
  localStorage.removeItem(LOCAL_STORAGE_ITEM_NAMES.defaultSpecialSelectionRule);
  sessionStorage.removeItem(SESSION_STORAGE_ITEM_NAMES.CSRFTOKEN);
  sessionStorage.removeItem(SESSION_STORAGE_ITEM_NAMES.IMPERSONATION_ALLOWED);
  sessionStorage.removeItem(SESSION_STORAGE_ITEM_NAMES.TPIS_TOKEN);
  clearImpersonationUserData();
}
export function clearImpersonationUserData() {
  localStorage.removeItem(LOCAL_STORAGE_ITEM_NAMES.impersonatingUser);
  localStorage.removeItem(LOCAL_STORAGE_ITEM_NAMES.impersonatedUsername);
  localStorage.removeItem(LOCAL_STORAGE_ITEM_NAMES.impersonatedRole);
  localStorage.removeItem(LOCAL_STORAGE_ITEM_NAMES.impersonatedVisiblePartners);
}
export function storeUserPreferenceInLocalStorage(key, value) {
  localStorage.setItem(key, value);
}
export function retrieveUserPreferenceFromLocalStorage(key) {
  return localStorage.getItem(key);
}
export function determineSelectedPartner(partners) {
  // get the selectedPartner from localStorage in case they selected one in a previous session
  let selectedPartner = localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.selectedPartner);
  const DEFAULT_PARTNER = "Comcast";
  let availablePartnerObj;
  if (partners != null) {
    if (typeof partners === 'string') {
      // It might be passed as a string if it was retrieved from localstorage
      availablePartnerObj = stringToObj(partners);
    } else {
      // It might already be an object if it was passed during login
      availablePartnerObj = partners;
    }
  }
  if (availablePartnerObj != null) {
    // The keys will be short names like rogers, shaw, cox, etc.
    const partnerKeys = Object.keys(partners);
    // If the partnerKeys that the user has access to includes the one they have selected, return
    if (partnerKeys.includes(selectedPartner)) {
      return {
        identifier: selectedPartner,
        title: availablePartnerObj[selectedPartner]
      };
    } else {
      if (partnerKeys.includes(DEFAULT_PARTNER)) {
        // If the partnerKeys includes the default partner, that can be returned
        selectedPartner = DEFAULT_PARTNER;
      } else {
        // Otherwise, we'll just return the first one available
        selectedPartner = partnerKeys[0];
      }
      if (selectedPartner === undefined || selectedPartner == null) {
        return null;
      }
      localStorage.setItem(LOCAL_STORAGE_ITEM_NAMES.selectedPartner, selectedPartner);
      return {
        identifier: selectedPartner,
        title: availablePartnerObj[selectedPartner]
      };
    }
  }
}